import Api from "../../Server/Api";
import { UPDATE } from "./types";
const api = new Api();

export const updateCategories = (data = {}) => {
	// return { ...data, type: UPDATE };
	return async (dispatch) => {
		const res = await api.get({ endpoint: "categories/" });
		console.log('CATGORICALLY');
		if(res?.length > 0 ){
			const data = {
				// specialty: res.filter(e => e.sector === "specialty").slice(0,4),
				// condition: res.filter(e => e.sector === "condition").slice(0,4),
				// procedure: res.filter(e => e.sector === "procedure").slice(0,4),
				// categories: res.filter((e, i) => i < 8),
				allcategories: res
			}
			dispatch({ ...data, type: UPDATE });
		}
	}
};
